export default __webpack_public_path__ + "static/media/Groupe 8620.b3de74c4.svg";